module.exports = __webpack_public_path__ + "static/media/best-time-en.be919a96.png";